// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-card[data-v-4e035e7e] {\n  flex-shrink: 0;\n  margin: auto;\n  width: 400px;\n  height: auto;\n  min-height: 770px;\n  padding: 32px;\n  gap: 1.5rem;\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 10px;\n  box-shadow: 5px 5px 10px 5px rgba(0, 0, 0, 0.2);\n  backdrop-filter: blur(10px);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
